import React from "react";
import {withTranslate} from "react-redux-multilingual";


const BranchCard = ({doctor, branch, translate, book, currentBranch}) => {

    return (

        <div className="branch" key={branch.id} hidden={currentBranch}>
            <div className="branch-header capitalized" title={branch.name}> {translate("branch_info") + " " +
            (branch.province_name ? branch.province_name : "")}
            </div>

            <div className="branch-details">
                <div className="branch-info">

                    <p className="d-flex">
                        <a target="_blank" rel="noopener noreferrer"
                           href={"https://maps.googleapis.com/maps/api/place/nearbysearch/json?location=" + branch.lat + "," + branch.lng + "&radius=1500&keyword=cruise&key=AIzaSyD6CkXgLTElPRdLHEg8zuYcM3vcAe-kmsw"}><span
                            className="icon">
                            <img src="/images/branch.png" className="money-icon" alt="branch"/>
                        </span></a>
                        <span>
                            {branch.name}
                        </span>
                    </p>

                    <p className="working_hours_start_end">
                        <span className="icon">
                            <img src="/images/time.png" className="money-icon" alt="time"/>
                        </span>
                        {branch.working_hours_start_end}
                    </p>

                    <p hidden={doctor && !doctor.is_premium} className="premium-fees-p">
                        <span className="icon">
                            <img src="/images/floos.png" className="money-icon" alt="money"/>
                        </span>
                        {branch.premium_fees + " " + translate("currency")}
                        <span className="premium-text-hint capitalized">&nbsp; {translate('premium_users_only')}</span>
                    </p>

                    <p className="fees-p">
                        <span className="icon">
                            <img src="/images/floos.png" className="money-icon" alt="money"/>
                        </span>
                        {branch.fees + " " + translate("currency")}
                    </p>


                </div>
                <div className="branch-book">
                    <button className="btn btn-book btn-block shadow-4d height-45"
                            onClick={() => book(branch)}>{translate("book")}</button>
                </div>
            </div>
        </div>
    )
};
export default withTranslate(BranchCard);